import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CreatePropertyPricingRule, PropertyPricingRule, PropertyPricingRuleUpdateRequest } from '../models/property.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PropertyPricingRuleService {
  private http = inject(HttpClient);

  private apiUrl = environment.apiUrl;

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      // Add other headers as needed, e.g., Authorization
      //'Authorization': `Bearer ${yourToken}`
    });
  }

  getPropertyPricing(id: string): Observable<PropertyPricingRule[]> {
    return this.http.get<PropertyPricingRule[]>(`${this.apiUrl}/property/pricing-rules/${id}`)
  }

  createPricingRule(request: CreatePropertyPricingRule): Observable<PropertyPricingRule> {
    return this.http.post<PropertyPricingRule>(`${this.apiUrl}/property/pricing-rules`, request);
  }

  patchPricingRule(id: number, request: Partial<PropertyPricingRuleUpdateRequest>): Observable<PropertyPricingRule> {
    return this.http.patch<PropertyPricingRule>(`${this.apiUrl}/property/pricing-rules/${id}`, request);
  }

  deletePricingRule(id: string) {
    return this.http.delete(`${this.apiUrl}/property/pricing-rules/${id}`);
  }
}